import AiAssistantDrawer from './AiAssistantDrawer'

export default AiAssistantDrawer
